<template>
  <ul>
    <template
            v-for="metaKey in labels"
            :key="metaKey">
      <li
              v-if="itemMeta?.[metaKey]"
              :class="labelClass">
        <component
                :is="iconComponent(metaKey)"
                :class="iconClass"/>
        <span :class="textClass">
            {{ itemMeta[metaKey] }}
        </span>
      </li>
    </template>
  </ul>
</template>
<script lang="ts" setup>
import {ProjectMetadata} from "~/types/Project/ProjectMetaData.enum";
import type {ProjectMeta} from "~/types/Project/ProjectMeta.interface";

const {
    itemMeta,
    labels = Object.values(ProjectMetadata),
    labelClass = 'border text-nowrap border-brand/20 rounded-full px-2 py-1 text-xs text-secondary/33 flex items-center gap-1',
    iconClass = 'text-brand size-2',
    textClass = 'text-grey text-xs'
} = defineProps<{
    itemMeta: ProjectMeta;
    labels?: ProjectMetadata[];
    labelClass?: string;
    iconClass?: string;
    textClass?: string;
}>();

function iconComponent(iconRef: string) {
    const iconRefKebab = iconRef.charAt(0).toUpperCase() + iconRef.slice(1);
    return defineAsyncComponent(() =>
            import(`~/components/icon/${iconRefKebab}.vue`)
    )
}
</script>